import LazyLoad from "vanilla-lazyload";

// Resize elements
const resizeElements = () => {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
};

if (document.querySelector('.js-menu-opener')) {
	document.querySelector('.js-menu-opener').addEventListener('click', (e) => {
		e.stopImmediatePropagation();
		e.preventDefault();
		if (!e.target.classList.contains('menu-opener--active')) {
			e.target.classList.add('menu-opener--active');
			document.querySelector('.wp-block-responsive-menu-wrapper').classList.add('wp-block-responsive-menu-wrapper--active');
			document.querySelector('.site-header').classList.add('site-header--menu-is-open');
		} else {
			e.target.classList.remove('menu-opener--active');
			document.querySelector('.wp-block-responsive-menu-wrapper').classList.remove('wp-block-responsive-menu-wrapper--active');
			document.querySelector('.site-header').classList.remove('site-header--menu-is-open');
		}
	});
}

window.addEventListener("load", () => {
    resizeElements();

    // lazy load pictures 
    new LazyLoad();
});

window.addEventListener("resize", () => {
    resizeElements();
});

window.addEventListener("scroll", () => {
    if (window.innerHeight * 0.8 < window.scrollY) {
        document.querySelector('header.site-header').classList.add('site-header--mini');
    } else {
        document.querySelector('header.site-header').classList.remove('site-header--mini');
    }
});